import React from 'react';
import { ChatMessage as ChatMessageType } from './types';
import './ChatMessage.css';

interface ChatMessageProps {
  message: ChatMessageType;
}

// Simple markdown renderer without external dependencies
const renderMarkdown = (text: string) => {
  // Replace bold text **text** with <strong>
  let html = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  
  // Replace line breaks with <br>
  html = html.replace(/\n/g, '<br>');
  
  // Replace bullet points (simple version)
  html = html.replace(/^-\s(.+)<br>/gm, '• $1<br>');
  
  // Replace numbered lists (simple version)
  html = html.replace(/^(\d+)\.\s(.+)<br>/gm, '$1. $2<br>');
  
  return html;
};

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const isUser = message.role === 'user';

  return (
    <div className={`chat-message ${isUser ? 'user-message' : 'assistant-message'}`}>
      <div className="message-avatar">
        {isUser ? (
          <div className="avatar user-avatar">👤</div>
        ) : (
          <div className="avatar assistant-avatar">🤖</div>
        )}
      </div>

      <div className="message-content">
        <div className="message-bubble">
          {isUser ? (
            <p>{message.content}</p>
          ) : (
            <div 
              className="markdown-content"
              dangerouslySetInnerHTML={{ __html: renderMarkdown(message.content) }}
            />
          )}
        </div>

        {/* {!isUser && message.sources && message.sources.length > 0 && (
          <div className="message-sources">
            <details>
              <summary>
                📚 Sources ({message.sources.length})
              </summary>
              <div className="sources-list">
                {message.sources.map((source, index) => (
                  <div key={index} className="source-item">
                    <div className="source-header">
                      <span className="source-document">{source.document}</span>
                      <span className="source-relevance">
                        {Math.round(source.relevance_score * 100)}% relevant
                      </span>
                    </div>
                    <div className="source-section">
                      {source.section}
                      {source.subsection && ` > ${source.subsection}`}
                    </div>
                  </div>
                ))}
              </div>
            </details>
          </div>
        )} */}

        {/* {!isUser && message.metadata && (
          <div className="message-metadata">
            <span className="metadata-time">
              ⚡ {message.metadata.processing_time_ms}ms
            </span>
            {message.metadata.chunks_used && (
              <span className="metadata-chunks">
                • {message.metadata.chunks_used} sources
              </span>
            )}
          </div>
        )} */}

        <div className="message-time">
          {message.timestamp.toLocaleTimeString([], { 
            hour: '2-digit', 
            minute: '2-digit' 
          })}
        </div>
      </div>
    </div>
  );
};
